export default __webpack_public_path__ + "static/media/C&B.54a5f722.jpg";